// extracted by mini-css-extract-plugin
export default {"container1":"CI_container1__qp5cB"};